exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.FAQ_panel_12Id > ul > li {\n  padding-bottom: 12px;\n}\n@media (min-width: 768px) {\n  .FAQ_panel_12Id > ul > li {\n    padding-bottom: 16px;\n  }\n}\n.FAQ_title_1dm5 {\n  margin-bottom: 16px;\n}\n@media (min-width: 768px) {\n  .FAQ_title_1dm5 {\n    margin-bottom: 20px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"panel": "FAQ_panel_12Id",
	"title": "FAQ_title_1dm5"
};